function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class2, _class3, _descriptor, _temp;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint no-mixed-spaces-and-tabs: "off" */

/* eslint-disable */
import { Component, register, bind, emitEvent, el } from 'ovee.js';
import gsap from 'gsap/all';
import axios from 'axios';

var filter = function filter(list, selector) {
  list = _toConsumableArray(list);
  return list.filter(function (item) {
    return item.matches(selector);
  });
};

var each = function each(list) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  list.forEach(function (item) {
    return callback(item);
  });
};

var is = function is(element, selector) {
  if (selector.nodeType) {
    return element === selector;
  }

  var elements = typeof selector === 'string' ? document.querySelectorAll(selector) : selector;
  var elementsLength = elements.length;

  while (elementsLength--) {
    if (elements[elementsLength] === element) {
      return true;
    }
  }

  return false;
};

var DEFAULT_FORMS_VERSION = 2;

var _class = (_dec = register('form-base'), _dec2 = el('.form__ajax-message', {
  list: true
}), _dec3 = bind('focus', 'input, select, textarea'), _dec4 = bind('blur', 'input, select, textarea'), _dec5 = bind('keyup', 'input, textarea'), _dec6 = bind('click', '.agreement'), _dec7 = bind('open'), _dec8 = bind('submit'), _dec(_class2 = (_class3 = (_temp = /*#__PURE__*/function (_Component) {
  _inherits(_class3, _Component);

  var _super = _createSuper(_class3);

  function _class3() {
    var _this;

    _classCallCheck(this, _class3);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_assertThisInitialized(_this), "ajaxMessage", _descriptor, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "version", DEFAULT_FORMS_VERSION);

    _defineProperty(_assertThisInitialized(_this), "successMessage", void 0);

    _defineProperty(_assertThisInitialized(_this), "defaultSelectValue", void 0);

    return _this;
  }

  _createClass(_class3, [{
    key: "init",
    value: function init() {
      var _this$$app$getConfig$, _this$$element$queryS, _this$$element$queryS2;

      this.version = (_this$$app$getConfig$ = this.$app.getConfig().formsVersion) !== null && _this$$app$getConfig$ !== void 0 ? _this$$app$getConfig$ : DEFAULT_FORMS_VERSION;
      this.successMessage = document.querySelector('.form__message');
      this.defaultSelectValue = (_this$$element$queryS = this.$element.querySelector('select')) === null || _this$$element$queryS === void 0 ? void 0 : (_this$$element$queryS2 = _this$$element$queryS.children[0]) === null || _this$$element$queryS2 === void 0 ? void 0 : _this$$element$queryS2.textContent;
      this.phoneRegex = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
      this.emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      this.textRegex = /^[A-Za-z]+$/;
    }
  }, {
    key: "inputFocusHandler",
    value: function inputFocusHandler(_ref) {
      var target = _ref.target;
      var prev = target.previousElementSibling;

      if (prev) {
        prev.classList.add('is-animated');
      }
    }
  }, {
    key: "inputBlurHandler",
    value: function inputBlurHandler(_ref2) {
      var target = _ref2.target;
      var parentNode = target.parentNode;
      target.classList.remove('has-error');
      target.nextElementSibling.classList.remove('is-visible');
      var prev = target.previousElementSibling;
      this.targetValue = target.value;

      if (this.targetValue != '' && this.targetValue != ' ') {
        target.classList.add('is-filled');

        if (prev) {
          target.previousElementSibling.classList.add('is-animated');
        }

        if (target.getAttribute('name') === 'phone') {
          if (!this.targetValue.match(this.phoneRegex)) {
            this.$element.classList.add('has-error-phone');
          } else {
            this.$element.classList.remove('has-error-phone');
          }
        }

        if (target.getAttribute('name') === 'email') {
          if (!this.targetValue.match(this.emailRegex)) {
            this.$element.classList.add('has-error-email');
          } else {
            this.$element.classList.remove('has-error-email');
          }
        } // if ( target.getAttribute('name') === 'username' ) {
        // 	if ( !this.targetValue.match(this.textRegex) ) {
        // 		this.$element.classList.add('has-error-name')
        // 	} else {
        // 		this.$element.classList.remove('has-error-name')
        // 	}
        // }
        // if ( target.getAttribute('name') === 'usersurname' ) {
        // 	if ( !this.targetValue.match(this.textRegex) ) {
        // 		this.$element.classList.add('has-error-surname')
        // 	} else {
        // 		this.$element.classList.remove('has-error-surname')
        // 	}
        // }

      } else {
        target.classList.remove('is-filled');

        if (target.getAttribute('name') === 'phone') {
          this.$element.classList.remove('has-error-phone');
        }

        if (target.getAttribute('name') === 'email') {
          this.$element.classList.remove('has-error-email');
        }

        if (target.getAttribute('name') === 'username') {
          this.$element.classList.remove('has-error-name');
        }

        if (target.getAttribute('name') === 'usersurname') {
          this.$element.classList.remove('has-error-surname');
        }

        if (prev) {
          target.previousElementSibling.classList.remove('is-animated');
        }
      }

      if (parentNode.classList.contains('custom-select')) {
        parentNode.classList.remove('has-error');
      }
    }
  }, {
    key: "clearErrors",
    value: function clearErrors(_ref3) {
      var target = _ref3.target;

      if (target.value != '' && target.value.length > 2 && target.value != ' ') {
        target.classList.remove('has-error');
        target.nextElementSibling.classList.remove('is-visible');
      }

      if (target.value == '') {
        if (target.getAttribute('name') === 'phone') {
          this.$element.classList.remove('has-error-phone');
        }

        if (target.getAttribute('name') === 'email') {
          this.$element.classList.remove('has-error-email');
        }

        if (target.getAttribute('name') === 'username') {
          this.$element.classList.remove('has-error-name');
        }

        if (target.getAttribute('name') === 'usersurname') {
          this.$element.classList.remove('has-error-surname');
        }
      }
    }
  }, {
    key: "customCheckboxClickHandler",
    value: function customCheckboxClickHandler(_ref4) {
      var target = _ref4.target;
      var checkboxInput = target.querySelector('input[type="checkbox"]');
      var checkboxError = target.querySelector('.agreement__error');
      target.classList.remove('has-error');

      if (checkboxInput) {
        checkboxInput.classList.remove('has-error');
      }

      if (checkboxError) {
        checkboxError.classList.remove('is-visible');
      }
    }
  }, {
    key: "openHandler",
    value: function openHandler() {
      if (this.$element.dataset.formNoReset === undefined) {
        var inputs = this.$element.querySelectorAll('input[type=text], input[type=tel], input[type=number], select, input[type=email], textarea');
        var checkboxes = this.$element.querySelectorAll('input[type=checkbox]');
        each(inputs, function (input) {
          input.value = '';
          input.classList.remove('is-filled');
          emitEvent(input, 'change');
        });
        each(checkboxes, function (checkbox) {
          checkbox.checked = false;
          emitEvent(checkbox, 'change');
        });
      }
    }
  }, {
    key: "submitHandler",
    value: function submitHandler(e) {
      var _this2 = this;

      e.preventDefault(); // this.errors = this.$element.querySelectorAll('.has-error');

      if (!this.$element.classList.contains('has-error-phone') && !this.$element.classList.contains('has-error-email') && !this.$element.classList.contains('has-error-name') && !this.$element.classList.contains('has-error-surname')) {
        this.enableLoading();
        this.hideAjaxMessage();
        this.removeErrors(); // this.formGroups = document.querySelectorAll('.form__group');
        // this.formGroupsCta = document.querySelector('.form__cta');
        // this.formGroupsHeading = document.querySelector('.form__heading');
        // this.formGroupsAgreement = document.querySelector('.form__agreement');
        // this.formGroups.forEach(group => {
        // 	group.classList.add('is-hidden');
        // });
        // this.formGroupsCta.classList.add('is-hidden');
        // this.formGroupsHeading.classList.add('is-hidden');
        // this.formGroupsAgreement.classList.add('is-hidden');
        // setTimeout(() => {
        // 	this.formGroups.forEach(group => {
        // 		group.classList.remove('is-hidden');
        // 		this.formGroupsCta.classList.remove('is-hidden');
        // 		this.formGroupsHeading.classList.remove('is-hidden');
        // 		this.formGroupsAgreement.classList.remove('is-hidden');
        // 	});
        // }, 2000)

        this.submit().then(function () {
          _this2.disableLoading();

          if (window.grecaptcha) {
            grecaptcha.reset();
          }
        });
      }
    }
  }, {
    key: "hideAjaxMessage",
    value: function hideAjaxMessage() {
      each(this.ajaxMessage, function (msg) {
        return msg.style.display = 'none';
      });
    }
  }, {
    key: "removeErrors",
    value: function removeErrors() {
      var inputs = this.$element.querySelectorAll('input, select, textarea, select, .custom-select');
      each(inputs, function (input) {
        input.classList.remove('has-error');
        input.nextElementSibling.classList.remove('is-visible');
        emitEvent(input, 'blur');
      });
    }
  }, {
    key: "showErrorMsg",
    value: function showErrorMsg() {
      var errorMsg = filter(this.ajaxMessage, '.has-error');

      if (errorMsg.length > 0) {
        gsap.to(errorMsg, {
          opacity: 1,
          duration: 0.4,
          onStart: function onStart() {
            each(errorMsg, function (msg) {
              return msg.style.display = 'block';
            });
          }
        });
      }
    }
  }, {
    key: "showSuccessMsg",
    value: function showSuccessMsg() {
      var _this3 = this;

      if (!this.successMessage) return;
      this.successMessage.classList.add('is-visible');
      this.$element.classList.add('message-ok');
      setTimeout(function () {
        _this3.$element.classList.remove('message-ok');
      }, 2000);
      setTimeout(function () {
        _this3.successMessage.classList.remove('is-visible');
      }, 3000);
    }
  }, {
    key: "endpointUrl",
    value: function endpointUrl() {
      if (this.version === 1) {
        return "".concat(ajaxurl, "?action=form_").concat(this.action);
      }

      var baseUrl = document.querySelector('link[rel="https://api.w.org/"]').href;
      return "".concat(baseUrl, "owd-forms/v2/forms/").concat(this.action, "/submit");
    }
  }, {
    key: "endpointHeaders",
    value: function endpointHeaders() {
      return {};
    }
  }, {
    key: "filterData",
    value: function filterData(data) {
      return data;
    }
  }, {
    key: "getErrorsFromResponse",
    value: function getErrorsFromResponse(response) {
      var _response$data, _response$data$data;

      if (this.version === 1) {
        return (response === null || response === void 0 ? void 0 : response.errors) || [];
      } // FIXME: remove nested data object


      return (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$data = _response$data.data) === null || _response$data$data === void 0 ? void 0 : _response$data$data.errors) || {};
    }
  }, {
    key: "checkResponse",
    value: function checkResponse(response, status) {
      if (this.version === 1) {
        return ['200', '201', 200, 201].includes(status) && !!response.result;
      }

      if (status === 403 && (response === null || response === void 0 ? void 0 : response.code) === 'rest_cookie_invalid_nonce') {
        document.location.reload();
      }

      return [200, 201, '200', '201'].includes(status);
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this4 = this;

      var ajaxParams = {
        url: this.endpointUrl(),
        method: 'POST',
        headers: this.endpointHeaders(),
        data: new URLSearchParams(new FormData(this.$element)).toString() // URLSearchParams -> IE: Not supported

      };

      if (this.isMultiPart) {
        ajaxParams.data = new FormData(this.$element);
      }

      ajaxParams.data = this.filterData(ajaxParams.data);
      /* eslint no-undef: "off" */

      if (window.ga !== undefined) {
        try {
          ga('send', 'event', 'form', 'submit', this.action);
        } catch (e) {
          console.error(e);
        }
      }

      return axios(ajaxParams).then(function (response) {
        return [response.data, response.status];
      }).then(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            response = _ref6[0],
            status = _ref6[1];

        if (_this4.checkResponse(response, status)) {
          if (_this4.$element.dataset.formNoReset === undefined) {
            _this4.showSuccessMsg();

            var inputs = _this4.$element.querySelectorAll('input[type=file],input[type=text],input[type=tel],input[type=number],input[type=email],textarea');

            var checkboxes = _this4.$element.querySelectorAll('input[type=checkbox]');

            var select = _this4.$element.querySelector('select');

            each(inputs, function (input) {
              input.classList.remove('has-error');
              input.classList.remove('is-filled');
              input.value = '';
              input.previousElementSibling.classList.remove('is-animated');
              input.nextElementSibling.classList.remove('is-visible');
              emitEvent(input, 'change');
            });
            each(checkboxes, function (checkbox) {
              checkbox.classList.remove('has-error');
              checkbox.checked = false;
              var checkboxParent = checkbox.closest('.agreement');
              var errorElement = checkboxParent.querySelector('.agreement__error');

              if (checkboxParent) {
                checkboxParent.classList.remove('has-error');

                if (errorElement) {
                  errorElement.classList.remove('is-visible'); // errorElement.innerText = errorMessage;
                }
              }

              emitEvent(checkbox, 'change');
            });

            _this4.resetCustomSelect(select);

            _this4.removeErrorMessages();
          }

          emitEvent(_this4.$element, 'success', response);
        }
      })["catch"](function (e) {
        _this4.showErrorMsg();

        Object.keys(_this4.getErrorsFromResponse(e.response)).forEach(function (name) {
          var inputs = _this4.$element.querySelectorAll("input[name=\"".concat(name, "\"],input[name^=\"").concat(name, "[\"],textarea[name=\"").concat(name, "\"]"));

          var select = _this4.$element.querySelectorAll("select[name=\"".concat(name, "\"]"));

          var checkboxes = _this4.$element.querySelectorAll("input[type=checkbox][name=\"".concat(name, "\"]"));

          var radio = _this4.$element.querySelectorAll("input[type=radio][name=\"".concat(name, "\"]"));

          var errorMessage = _this4.getErrorsFromResponse(e.response)[name];

          each(inputs, function (input) {
            var mess = _this4.getErrorsFromResponse(e.response)[name];

            var errorElement = input.parentElement.querySelector('.form__field-error');
            if (!errorElement || !errorElement) return;
            input.classList.add('has-error');
            errorElement.classList.add('is-visible'); // errorElement.innerText = mess;

            emitEvent(input, 'error');
          });
          each(radio, function (customRadio) {
            if (!customRadio) return;
            var radioParent = customRadio.closest('.custom-radio');
            var errorElement = radioParent.querySelector('.form__field-error');

            if (radioParent) {
              radioParent.classList.add('has-error');

              if (errorElement) {
                errorElement.classList.add('visible');
                errorElement.innerText = errorMessage;
              }
            }

            emitEvent(customRadio, 'error');
          });
          each(checkboxes, function (customCheckbox) {
            if (!customCheckbox) return;
            var checkboxParent = customCheckbox.closest('.agreement');
            var errorElement = checkboxParent.querySelector('.agreement__error');

            if (checkboxParent) {
              checkboxParent.classList.add('has-error');

              if (errorElement) {
                errorElement.classList.add('is-visible'); // errorElement.innerText = errorMessage;
              }
            }

            emitEvent(customCheckbox, 'error');
          });
          each(select, function (customSelect) {
            if (!customSelect) return;
            var selectParent = customSelect.closest('.form__field--wrapper');
            var errorElement = selectParent.querySelector('.form__field--error');
            customSelect.closest('.form__select').classList.add('has-error');

            if (errorElement) {
              errorElement.classList.add('visible');
              errorElement.innerText = errorMessage;
            }

            emitEvent(customSelect, 'error');
          }); // FIXME: this condition is not working every time

          if (_this4.getErrorsFromResponse(e.response)['g-recaptcha-response']) {
            var ReCaptcha = _this4.$element.querySelector('.recaptcha');

            var errorElement = ReCaptcha.querySelector('span.base-form__error');
            if (!errorElement || !ReCaptcha) return;
            ReCaptcha.classList.add('has-error');
            errorElement.innerText = _this4.getErrorsFromResponse(e.response)['g-recaptcha-response'];
          }
        });

        var allErrors = _toConsumableArray(Object.keys(_this4.getErrorsFromResponse(e.response)));

        var allInputs = _this4.$element.querySelectorAll('input,select,textarea');

        allInputs.forEach(function (input) {
          if (!allErrors.includes(input.name)) {
            var _input$closest;

            input.classList.remove('has-error');
            var errorElement = (_input$closest = input.closest('.form__field--wrapper')) === null || _input$closest === void 0 ? void 0 : _input$closest.querySelector('.form__field-error');
            errorElement ? errorElement.classList.remove('visible') : null;
          }
        });
        emitEvent(_this4.$element, 'error');
      });
    }
  }, {
    key: "resetCustomSelect",
    value: function resetCustomSelect(select) {
      var _select$closest, _select$closest2;

      var selectContent = select.closest('.choices').querySelector('.choices__item--selectable');
      if (!selectContent) return;
      selectContent.classList.add('choices__placeholder');
      selectContent.dataset.value = '';
      selectContent.textContent = this.defaultSelectValue;
      select.children[0].value = '';
      select.children[0].textContent = this.defaultSelectValue;
      (_select$closest = select.closest('.has-selection')) === null || _select$closest === void 0 ? void 0 : _select$closest.classList.remove('has-selection');
      (_select$closest2 = select.closest('.form__select')) === null || _select$closest2 === void 0 ? void 0 : _select$closest2.classList.remove('has-error');
    }
  }, {
    key: "removeErrorMessages",
    value: function removeErrorMessages() {
      var errors = this.$element.querySelectorAll('.form__field-error');
      error.forEach(function (error) {
        error.innerText = '';
      });
    }
  }, {
    key: "enableLoading",
    value: function enableLoading() {
      this.$element.classList.add('loading');
    }
  }, {
    key: "disableLoading",
    value: function disableLoading() {
      this.$element.classList.remove('loading');
    }
  }, {
    key: "isMultiPart",
    get: function get() {
      return this.$element.getAttribute('enctype') === 'multipart/form-data';
    }
  }, {
    key: "action",
    get: function get() {
      return this.$element.dataset.formBase;
    }
  }]);

  return _class3;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class3.prototype, "ajaxMessage", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class3.prototype, "inputFocusHandler", [_dec3], Object.getOwnPropertyDescriptor(_class3.prototype, "inputFocusHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "inputBlurHandler", [_dec4], Object.getOwnPropertyDescriptor(_class3.prototype, "inputBlurHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "clearErrors", [_dec5], Object.getOwnPropertyDescriptor(_class3.prototype, "clearErrors"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "customCheckboxClickHandler", [_dec6], Object.getOwnPropertyDescriptor(_class3.prototype, "customCheckboxClickHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "openHandler", [_dec7], Object.getOwnPropertyDescriptor(_class3.prototype, "openHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "submitHandler", [_dec8], Object.getOwnPropertyDescriptor(_class3.prototype, "submitHandler"), _class3.prototype)), _class3)) || _class2);

export { _class as default };